import { render, staticRenderFns } from "./FrogetPass.vue?vue&type=template&id=e44a431c&"
import script from "./FrogetPass.vue?vue&type=script&lang=js&"
export * from "./FrogetPass.vue?vue&type=script&lang=js&"
import style0 from "./FrogetPass.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports